
define('promotion-helper',[ 'jquery', 'knockout', 'moment', 'underscore', 'eteration/eteration', 'eteration/ui/base-viewmodel', 'eteration/eteration-ajax', 
	'eteration/ui/login-viewmodel', 'eteration/widgets/ui-wingosharebox', 'ui-helper/cookie-helper', 'ajaxConsolidator' ,'ui-helper/gtm-helper' ],

function($, ko, moment, underscore, Eteration, BaseViewModel, etrAjax, loginView, WingoShareBoxWidget, cookieHelper, ajaxConsolidator, gtmHelper) {
	var wingoConf = [ [ 'big' ], [ 'vertical', 'big' ], [ 'horizontal', 'small', 'small' ], [ 'vertical', 'big', 'horizontal', 'horizontal' ], [ 'vertical', 'big', 'horizontal', 'small', 'small' ] ];
    var mainPageWingoConf = [ [ 'big' ], [ 'vertical', 'big' ], [ 'vertical', 'big', 'vertical' ] ];
    
	var promotionHelper;

	var PromotionHelper = function() {
		var self = this;
		self.globalDestinationList = new Object();

		self.fromCountryArray = [];
		self.toCountryArray = [];
		self.fromRegionArray = [];
		self.toRegionArray = [];
		self.fromCityArray = [];
		self.toCityArray = [];
		self.fromPortArray = [];
		self.toPortArray = [];
		self.cabinClass = [];
		self.urlSelectedAndThemeOptions = [];
		self.selectedThemeOptions = ko.observableArray([]);
		self.visaRequirement = 0; // 0 for don't care, 1 for yes, -1 for no
		self.originalWingoItems = ko.observableArray([]);
		self.processedWingoItems = ko.observableArray([]);// observable?
		var msLoggedIn =  false;
		var wishListCotrolled = false;

        self.wingoShareBoxComponent = ko.observable(new WingoShareBoxWidget.ViewModel());
        self.wingoShareBoxComponent().loadTemplates();
        self.wingoShareBoxViewModel = ko.observable(self.wingoShareBoxComponent().ViewModel({
            visibility : true
        }));

        self.userWishList = ko.observableArray();//observable? 
        self.promotionContainerCount = 0;
        self.comingFromUrl = ko.observable(false);
        

        self.initialSortPreference = function() {
            var sortItem = {};
            sortItem.sortBy = "promotionscore";
            sortItem.sortDirection = "descending";
            return sortItem;
        };
        self.selectedSortPreference = self.initialSortPreference();
		self.clearWingoParams = function() {
			
			self.originalWingoItems([]);
			self.processedWingoItems([]);
			$('#wingo').empty();
			$('#wingoMobile.carousel-inner').empty();
			$('#wingoMobile .carousel-inner').empty();
			carouselIndicators('#exploreourbestoffersmobilecarousel');
			self.globalDestinationList = new Object();
		};

		self.createQueryDataForDestinations = function() {
			var queryObject = {
				"schema" : "Destination",
				"template" : "Destination (Wingo layout)",
				"maxItems" : 100,
				"includeMetadata" : true,
				"orMetadata" : []
			};

			if (self.toCountryArray.length > 0) {
				var orMetadataObject = {
					"countries" : self.toCountryArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toRegionArray.length > 0) {
				orMetadataObject = {
					"region" : self.toRegionArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toCityArray.length > 0) {
				orMetadataObject = {
					"destinationcitycode" : self.toCityArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toPortArray.length > 0) {
				orMetadataObject = {
					"destinationcitycode" : self.toPortArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.selectedThemeOptions().length > 0) {
				orMetadataObject = {
					"destinationTags" : self.selectedThemeOptions()
				};
				queryObject.orMetadata.push(orMetadataObject);
			}
			if (self.urlSelectedAndThemeOptions.length > 0) {
				var tempArray = [];
				for (var i = 0; i < self.urlSelectedAndThemeOptions.length; i++) {
					tempArray = [ self.urlSelectedAndThemeOptions[i] ];
					orMetadataObject = {
						"destinationTags" : tempArray
					};
					queryObject.orMetadata.push(orMetadataObject);
				}
			}
			queryObject.visaRequirement = self.visaRequirement;

			return queryObject;
		};

		self.createQueryDataForPromotions = function() {
			var queryObject = {
				"schema" : "Promotion",
				"template" : "Promotion",
				"maxItems" : 199,
				"includeMetadata" : true,
				"nonExpiredTicketingEndDate" : true,
				"orMetadata" : []
			};
			if (self.fromCountryArray.length > 0) {
				var orMetadataObject = {
					"departurecountry" : self.fromCountryArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toCountryArray.length > 0) {
				orMetadataObject = {
					"arrivalcountry" : self.toCountryArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.fromRegionArray.length > 0) {
				orMetadataObject = {
					"departureregion" : self.fromRegionArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toRegionArray.length > 0) {
				orMetadataObject = {
					"arrivalregion" : self.toRegionArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.fromCityArray.length > 0) {
				orMetadataObject = {
					"destination_DepartureCityCode" : self.fromCityArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toCityArray.length > 0) {
				orMetadataObject = {
					"destination_ArrivalCityCode" : self.toCityArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.fromPortArray.length > 0) {
				orMetadataObject = {
					"departureairportcode" : self.fromPortArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.toPortArray.length > 0) {
				orMetadataObject = {
					"arrivalairportcode" : self.toPortArray
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.selectedThemeOptions().length > 0) {
				orMetadataObject = {
					"destinationTags" : self.selectedThemeOptions()
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (self.urlSelectedAndThemeOptions.length > 0) {
				var tempArray = [];
				for (var i = 0; i < self.urlSelectedAndThemeOptions.length; i++) {
					tempArray = [ self.urlSelectedAndThemeOptions[i] ];
					orMetadataObject = {
						"destinationTags" : tempArray
					};
					queryObject.orMetadata.push(orMetadataObject);
				}
			}

			if (self.cabinClass.length > 0) {
				orMetadataObject = {
					"cabinClass" : self.cabinClass
				};
				queryObject.orMetadata.push(orMetadataObject);
			}

			if (typeof self.selectedSortPreference != "undefined") {
				queryObject.sortBy = self.selectedSortPreference.sortBy;
				queryObject.sortDirection = self.selectedSortPreference.sortDirection;

			}

			queryObject.visaRequirement = self.visaRequirement;
			return queryObject;

		};
		
		var filterArrayByField = function (component, fieldName, arrayName) {
           if (typeof (component.keywords[fieldName]) != "undefined") {
               return _.contains(self[arrayName],component.keywords[fieldName].toUpperCase());
           }
	    };
		
		self.applyFiltersToSmartTargetQueryResults = function(response, _callback) {
			if (!response || !response.data ||!response.data.components || response.data.components == 0) {
				_callback([]);
			} else {

				var filteredResult = [];
				for (var k = 0; k < components.length; k++) {
					filteredResult.push(components[k]);
				}
				if (self.fromCountryArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "departurecountry", "fromCountryArray");
					});

				}

				if (self.toCountryArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "arrivalcountry", "toCountryArray");
					});
				}

				if (self.fromRegionArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "departureregion", "fromRegionArray");
					});
				}

				if (self.toRegionArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "arrivalregion", "toRegionArray");
					});
				}

				if (self.fromCityArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "destination_DepartureCityCode", "fromCityArray");
					});
				}

				if (self.toCityArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "destination_ArrivalCityCode", "toCityArray");
					});
				}

				if (self.fromPortArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "departureairportcode", "fromPortArray");
					});
				}

				if (self.toPortArray.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "arrivalairportcode", "toPortArray");
					});
				}
				if (self.cabinClass.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						return filterArrayByField(component, "cabinClass", "cabinClass");
					});
				}
				if (self.selectedThemeOptions().length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {
						if (typeof component.keywords.destinationTags != 'undefined') {
							var compDestinationTags = [];

							if (typeof component.keywords.destinationTags === 'string') {
								compDestinationTags = [ component.keywords.destinationTags ];
							} else {
								compDestinationTags = component.keywords.destinationTags;
							}

							if (typeof (compDestinationTags) != "undefined") {
								for (var m = 0; m < compDestinationTags.length; m++) {
									if (_.contains(self.selectedThemeOptions(), compDestinationTags[m])) {
										return true;
									}
								}
							}
						}
					});
				}

				if (self.urlSelectedAndThemeOptions.length > 0) {
					filteredResult = _.filter(filteredResult, function(component) {

						if (typeof component.keywords.destinationTags != 'undefined') {
							var compDestinationTags = [];

							if (typeof component.keywords.destinationTags === 'string') {
								compDestinationTags = [ component.keywords.destinationTags ];
							} else {
								compDestinationTags = component.keywords.destinationTags;
							}

							if (typeof (compDestinationTags) != "undefined") {
								var result = true;
								for (var m = 0; m < self.urlSelectedAndThemeOptions.length; m++) {
									result = result & (_.contains(compDestinationTags, self.urlSelectedAndThemeOptions[m]));
								}

								return result;
							}
						}
					});
				}

				self.filterByVisaRequirement(filteredResult, function(newComponents2) {
					filteredResult = newComponents2;

					self.filterRecurringDestinations(filteredResult, true, function(newComponents3) {
						filteredResult = newComponents3;
					});

					_callback(filteredResult);
				});
			}
		};
		
        self.filterRecurringDestinations = function(components, isPromotion, _callback) {
            var newComponents = [];
            for (var i = 0; i < components.length; i++) {
                if (typeof self.globalDestinationList[components[i].toCityCode] == "undefined") {
                    newComponents.push(components[i]);
                    if (isPromotion) {
                        self.globalDestinationList[components[i].toCityCode] = components[i].keywords.code;
                    } else {
                        self.globalDestinationList[components[i].toCityCode] = components[i].toCityCode;
                    }
                } else {
                    if (isPromotion) {
                        if ((self.globalDestinationList[components[i].toCityCode]).indexOf(components[i].keywords.code) < 0) {
                            newComponents.push(components[i]);
                            self.globalDestinationList[components[i].toCityCode] = self.globalDestinationList[components[i].toCityCode] + components[i].keywords.code;
                        }
                    } 
                }
            }
            _callback(newComponents);
        };

        self.filterByVisaRequirement= function(components, _callback) {
            if (self.visaRequirement == 0) {
                _callback(components);
            } else if (self.visaRequirement == 1) {
                var newComponents = [];
                for (var i = 0; i < components.length; i++) {
                    if (components[i].requiresVisa) {
                        newComponents.push(components[i]);
                    }
                }
                _callback(newComponents);
            } else {
                newComponents = [];
                for (i = 0; i < components.length; i++) {
                    if (components[i].requiresVisa == false) {
                        newComponents.push(components[i]);
                    }
                }
                _callback(newComponents);
            }

        };
        var dataLayerUtil = (function(){
            
            var   _map = {}; 
            
            var  _sent = {}; 
            
            var  _carouselId;
             
            var convertListItem = function(component,index){
                 var obj = convert(component,index);
                 obj.position= component.parentIndex+"|"+(1+index);
                 return obj;
            };
           
            var wrapConvert = function(parentIndex,components){
                return components.map(function(component,index){
                       component.parentIndex  = parentIndex;
                        return convertListItem(component, index);
                });
            };
            
            var convert  = function(component, slotIndex){
                var obj = {};
                var keywords = component.keywords;
                obj.id = keywords.code;
                var  url =   component.html.match(/ucak-bileti\/(.*-ucak-bileti)\//);
                if(url&& url[1]){
                    url = url[1];
                }
                else{
                    url  = component.html.match(/flights\/(flights-to-.*)\/\#/);
                    if(url&&url[1]){
                        url = url[1];
                    }
                }
                obj.name =keywords.departureairportcode +"|"+url;
                obj.creative = keywords.currency + " "+ keywords.price + "|"+keywords.ticketingtype;
                 return obj;
            };
             
            var  addPromos = function(index, views){
               
                 _map[index] =  wrapConvert(index,views);
                 return returnObj;
             
             };
             
             var pushView = function(id){
                
                 if(!_sent[id]&&_map[id]){
                     _sent[id] = true;
                    gtmHelper.pushPromotionsImpData(_map[id]);
                    
                 }
             };
             
             var ensureCarouselIdSet = function(){
                  if(!_carouselId){
                        _carouselId =!window.isPhoneOrTablet  ? "#exploreourbestofferscarousel" : "#wingoMobile";
                    }
                 
                 
             };
             
             var pushActiveView =  function(){
                    
                     ensureCarouselIdSet();
                    
                   
                     var activeEl = $(_carouselId).find(".item.active");
                     if(activeEl.length==1){
                         var domId = $(activeEl).attr("id");
                         var id = domId.replace(/carouselContainerMobile|carouselContainer/g,"");
                     
                         pushView(id);
                     }
                     return returnObj;
             };
             
             var addEventListener = function(){
                    ensureCarouselIdSet();
                     $(_carouselId).on('slid.bs.carousel', function () {
                         
                         pushActiveView();
 			   
 			        });
 			        
 			        return returnObj;
                 
             };
             
             var noob = function(){
                 return returnObj;
             };
             
             var conditionalClick = function (callback) {
                var isDone = false;

                return function(e) {
                   
                    if (isDone === true)
                    {
                      
                        isDone = false;
                        window.location.href = this.href;
                        return;
                    }
                    
                    e.preventDefault();
                    var that = this;
                    callback.apply(this, arguments).done(function(){
                         
                           isDone = true;
                          $(that).trigger(e.type);
                    });
                   
                 
                }
            };
            
         var onPromotionClick = function(btn){
                 
                  var data = btn.data("datalayer");
                  data.data.parentIndex = data.parentIndex;
                  data = convertListItem(data.data, data.position);
                  var deferred = $.Deferred();
                  gtmHelper.pushPromotionClickData([data], function(){
                            deferred.resolve(arguments);
                  });
                   return    deferred.promise();
         };
         
         var getProductClick = function(callback){
            
             
             return function(){
                  callback.apply(this,arguments);
                 return  onPromotionClick($(this));
                
             }
         };
            
           var  addProductClickEvent = function(element,callback){
                        element.on('click',conditionalClick(getProductClick(callback)));
                        return returnObj;
                    };
            var addProductClickData = function(element,data){
                        element.data("datalayer",data);
                        return returnObj;
                     };
             
             var exports = function (){
                 var obj = {};
                  if($('#schedule').length > 0){
                     obj = {
                         addEventListener : addEventListener,
                         addPromos : addPromos ,
                         pushActiveView : pushActiveView,
                        addProductClickEvent : addProductClickEvent,
                        addProductClickData: addProductClickData,
                        onPromotionClick: onPromotionClick
                      };
                 }
                 else{
                    
                     obj.addEventListener  =noob;
                     obj.addPromos = noob;
                     obj.pushActiveView = noob;
                     obj.onProductClick = noob;
                     obj.addProductClickData = noob;
                     obj.addProductClickEvent = function(element,callback){
                         element.on('click', callback);
                         return returnObj;
                     };
                     obj.onPromotionClick  = noob;
                 }
                 return obj;
                 
             };
             
             var returnObj  = exports();
             
     
             
             
             
             return returnObj;
             
         }());
        
		self.populateWingoDataUsingResponse = function(response) {
			if (!response || !response.data || typeof response.data.components == "undefined" ||response.data.components ==null || response.data.components.length == 0) {
				$('#exploreourbestofferscarousel .left.carousel-control').addClass('hide').removeClass('show');
				$('#exploreourbestofferscarousel .right.carousel-control').addClass('hide').removeClass('show');
				if (!window.isPhoneOrTablet) {
					carouselIndicators('#exploreourbestofferscarousel');
				} else {
					carouselIndicators('#exploreourbestoffersmobilecarousel');
				}
				return;
			}
			// IS USER LOGGED IN
			msLoggedIn=response.principal;
			// AT FIRST ORIGINAL LIST AND PROCESSED IS EQUAL
			self.originalWingoItems(self.originalWingoItems().concat(response.data.components));

			self.processedWingoItems(self.processedWingoItems().concat(response.data.components));

			if (typeof response.data.components[0].stPromotion != "undefined") {
				sortSmartTargetPromotions();
			}

			self.updateHtmlUsingWingoData();
			dataLayerUtil.pushActiveView().addEventListener();
		};

       function sortSmartTargetPromotions() {
            if (self.selectedSortPreference.sortBy == "price") {
                if (self.selectedSortPreference.sortDirection == "ascending") {
                    self.processedWingoItems.sort(self.sortByPriceFunctionSmallToBig);

                } else {
                    self.processedWingoItems.sort(self.sortByPriceFunctionBigToSmall);
                }
            } else if (self.selectedSortPreference.sortBy == "name") {
                if (self.selectedSortPreference.sortDirection == "ascending") {
                    self.processedWingoItems.sort(self.sortByNameFunctionDirectionAtoZ);

                } else {
                    self.processedWingoItems.sort(self.sortByNameFunctionDirectionZtoA);
                }

            }
       }
       $(window).on('resize', function() {
      		setTimeout(function(){
	       		self.updateHtmlUsingWingoData();
	    		if (window.isPhoneOrTablet) {
	    			carouselIndicators('#wingo');
	    		} else {
	    			carouselIndicators('#wingoMobile');
	    		}
      		},100);
      	});
		self.updateHtmlUsingWingoData = function() {
			var carouselContainer = "";

			var totalCarouselItemCount = $('#wingo .item .wingo-grid-img').length;
			var containerName = "";
			var isItMainPage = ($('#schedule').length > 0);
			if (!window.isPhoneOrTablet) {
				containerName = "#carouselContainer";
				var forStart = 0;
				var forLast = 0;
				var totalCarouselCount;
				function wingoWebCallForWYW() {

					var dataSet = [];

					totalCarouselItemCount = $('#wingo .item .wingo-grid-img').length;
					forStart = totalCarouselItemCount;
					forLast = totalCarouselItemCount + 5 > self.processedWingoItems().length ? self.processedWingoItems().length : totalCarouselItemCount + 5;
					for (var j = forStart; j < forLast; j++) {
						dataSet.push(self.processedWingoItems()[j]);
					}
					self.carouselLoader(containerName, dataSet, (totalCarouselCount + 1));
					self.promotionContainerCount=((totalCarouselCount + 1));

					return 0;
				}
				function wingoWebCallForMain() {
					self.carouselLoader(containerName, dataSet, (totalCarouselCount + 1));
					dataSet = [];
					self.promotionContainerCount=((totalCarouselCount + 1));
					carouselIndicators('#exploreourbestofferscarousel');
					return 0;
				}
				if (isItMainPage) {
					var dataSet = [];
					$('#wingo').html("");
					for (var ii = 1; ii <= self.processedWingoItems().length; ii++) {
						dataSet.push(self.processedWingoItems()[ii - 1]);
						totalCarouselCount = $('#wingo .item').length;
						if (ii % 3 === 0 || ii === self.processedWingoItems().length) {
							if (totalCarouselCount == 0) {
								carouselContainer = '<div class="item active" id="carouselContainer' + (totalCarouselCount + 1) + '"></div>';
								$('#exploreourbestofferscarousel .left.carousel-control').addClass('hide').removeClass('show');
								$('#exploreourbestofferscarousel .right.carousel-control').addClass('hide').removeClass('show');
							} else {
								carouselContainer = '<div class="item" id="carouselContainer' + (totalCarouselCount + 1) + '"></div>';
								$('#exploreourbestofferscarousel .left.carousel-control').removeClass('hide').addClass('show');
								$('#exploreourbestofferscarousel .right.carousel-control').removeClass('hide').addClass('show');
							}
							$.when($('#wingo').append(carouselContainer)).done(wingoWebCallForMain());
						}
					}
				} else {
					var promotionsFives = Math.ceil((self.processedWingoItems().length - totalCarouselItemCount) / 5);
					$('#wingoMobile .carousel-inner').html("");
					for (var ka = 0; ka < promotionsFives; ka++) {
						totalCarouselCount = $('#wingo .item').length;
						if (totalCarouselCount == 0) {
							carouselContainer = '<div class="item active" id="carouselContainer' + (totalCarouselCount + 1) + '"></div>';
						} else {
							carouselContainer = '<div class="item" id="carouselContainer' + (totalCarouselCount + 1) + '"></div>';
						}
						$.when($('#wingo').append(carouselContainer)).done(wingoWebCallForWYW());
					}
				}
			} else {

				containerName = "#carouselContainerMobile";
				var wingoMobileForFirst = $('#wingoMobile .item .wingo-grid-img').length;
				var wingoMobileForLast = ((wingoMobileForFirst + 5) > self.processedWingoItems().length) ? self.processedWingoItems().length : wingoMobileForFirst + 5;
				function wingoMobileCall(mainOrNot) {
                    self.carouselLoader(containerName, dataSetMobile, (i + 1));
                    self.promotionContainerCount = (self.promotionContainerCount + 1);
                    if (mainOrNot) {
                        carouselIndicators('#wingoMobile');
                    }
                    return 0;
                }
				for (var i = wingoMobileForFirst; i < wingoMobileForLast; i++) {
					var dataSetMobile = [];
					dataSetMobile.push(self.processedWingoItems()[i]);
					var tmpItemMobile = "";
					if (i < 5) {
						tmpItemMobile = '<div class="item active" id="carouselContainerMobile' + (i + 1) + '"></div>';
					} else {
						tmpItemMobile = '<div class="item " id="carouselContainerMobile' + (i + 1) + '"></div>';
					}
					if (isItMainPage) {// if it's main page

						$.when($('#wingoMobile .carousel-inner').append(tmpItemMobile)).done(wingoMobileCall(isItMainPage));

					} else {
						$.when($('#wingoMobile').append(tmpItemMobile)).done(wingoMobileCall(isItMainPage));
					}

				}

			}
			$(document).trigger('carouselLoadedEvnt');
			$('.ourfleetcarousel a.carousel-control').on('click', function() {
				if ($(this).hasClass('carousel-control-left')) {
					$('.ourfleetcarousel').carousel('prev');
				}
				if ($(this).hasClass('carousel-control-right')) {
					$('.ourfleetcarousel').carousel('next');
				}
			});
			self.checkWishList();

		};


        self.carouselLoader = function(screen, components, index) {
             var htmlRowColTmp = '';
            var el = $(screen + index);
            var module = 'wingoblock';
            var publicationId = $("meta[name=PublicationID]").attr("content");
            dataLayerUtil.addPromos(index,components);
            if ($('#schedule').length < 1) {// if it's not main page
                switch (components.length) {
                case 5:
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-3 hover-links-wrapper c1_0"></div>' + '<div class="col-md-9 hover-links-wrapper c1_1"></div>' + '</div>' + '<div class="row">' + '<div class="col-md-6 hover-links-wrapper c1_2"></div>'
                            + '<div class="col-md-3 hover-links-wrapper c1_3"></div>' + '<div class="col-md-3 hover-links-wrapper c1_4"></div>' + '</div>';
                    break;
                case 4:
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-3 hover-links-wrapper c1_0"></div>' + '<div class="col-md-9 hover-links-wrapper c1_1"></div>' + '</div>' + '<div class="row">' +

                    '<div class="col-md-6 hover-links-wrapper c1_2"></div>' + '<div class="col-md-6 hover-links-wrapper c1_3"></div>' + '</div>';

                    break;
                case 3:
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-6 hover-links-wrapper c1_0"></div>' + '<div class="col-md-3 hover-links-wrapper c1_1"></div>' + '<div class="col-md-3 hover-links-wrapper c1_2"></div>' + '</div>';

                    break;
                case 2:
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-3 hover-links-wrapper c1_0"></div>' + '<div class="col-md-9 hover-links-wrapper c1_1"></div>' + '</div>';

                    break;
                case 1:
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-12 hover-links-wrapper c1_0"></div>' + '</div>';

                    break;
                default:
                    break;
                }
            } else {
                if (!window.isPhoneOrTablet) {
                    switch (components.length) {
                    case 3:
                        htmlRowColTmp = '<div class="row">' + '<div class="col-md-3 hover-links-wrapper c1_0"></div>' + '<div class="col-md-6 hover-links-wrapper c1_1"></div>' + '<div class="col-md-3 hover-links-wrapper c1_2"></div>' + '</div>';
                        
                        break;
                    case 2:
                        htmlRowColTmp = '<div class="row">' + '<div class="col-md-3 hover-links-wrapper c1_0"></div>' + '<div class="col-md-9 hover-links-wrapper c1_1"></div>' + '</div>';
                        
                        break;
                    case 1:
                        htmlRowColTmp = '<div class="row">' + '<div class="offset-md-2 col-md-8 hover-links-wrapper c1_0"></div>' + '</div>';
                        
                        break;
                    default:
                        break;
                    }
                } else {
                    htmlRowColTmp = '<div class="row">' + '<div class="col-md-12 hover-links-wrapper c1_0"></div>' + '</div>';
                }
            }

            if (!el) {
                el = $("#" + module);
            }
            el.html(htmlRowColTmp);


            for (var i = 0; i < components.length; i++) {
                var component = components[i];

                var html = component.html;

                var kw = component.keywords;

                var meta = component.metadata;

                var wish = component.wish;

            	var roundTrip =true;
                
            	var cabinClass = kw.cabinClass;
            	
                if(component.ticketingType){
                    if(component.ticketingType=='One Way'){
                        roundTrip=false;
                    }
                    else if(component.ticketingType=='Round Trip'){
                        roundTrip =true;
                    }
                }
                else{
                    roundTrip=component.roundTrip;
                }

                var to;
                var fromport = kw.departureairportcode;
                var toport = kw.arrivalairportcode;
                if (typeof kw.destination_ArrivalCityCode == 'undefined') {
                    to = kw.destinationcitycode;
                } else {
                    to = kw.destination_ArrivalCityCode;
                }

                var wishFlag = false;

                if (self.userWishList()) {
                    var userWishListTemp = self.userWishList();
                    for (var j = 0; j < userWishListTemp.length; j++) {
                        if (to == userWishListTemp[j].cityCode) {
                            wishFlag = true;
                        }
                    }
                }
                var wishClass = "";
                if (wishFlag) {
                    wishClass = "active";
                } else {
                    wishClass = "white";
                }

                var tmplate;
                var fromportTemp = '';
                if (fromport != 'undefined') {
                    fromportTemp = 'data-fromport="' + fromport + '"';
                }
                var toportTemp = '';
                if (toport != 'undefined') {
                    toportTemp = 'data-toport="' + toport + '"';
                }

                if (!window.isPhoneOrTablet) {

                    tmplate = '<div class="hover-links">' + '<a class="wishLink link ' + wishClass + '" data-to="' + to + '" data-wish="' + wish + '"><i class="fa fa-heart fa-md"></i></a>' + '<a class="shareLink link white"                 data-to="' + to + '"><i class="fa fa-share-square-o fa-md"></i></a>'
                            + '<a class="markerLink link white" ' + fromportTemp + ' ' + toportTemp + ' data-to="' + to + '"><i class="fa fa-map-marker fa-md"></i></a>' + '</div>';

                } else {

                    tmplate = '';

                }
                // html = html.replace('{.rollowericons}','<div
                // class="hover-links"><a class="white
                // bold">'+component.themes+'</a><a class="link
                // '+wishClass+'"><i class="fa fa-heart fa-md"></i></a> <a
                // class="link white"><i class="fa fa-share-square-o
                // fa-md"></i></a><a class="link white"><i class="fa
                // fa-map-marker fa-md"></i></a></div>');
                html = html.replace('{.rollowericons}', tmplate);
                var cItem = $(screen + index).find('.c1_' + i);
                var wingoClass;
                if ($('#schedule').length < 1) {// if it's not main page
                    wingoClass = wingoConf[components.length - 1][i];
                } else {

                    wingoClass = mainPageWingoConf[components.length - 1][i];
                }

                html = html.replace(/<img src=/g, "<img data-src=");
                cItem.append(html);
                var wingoBig = cItem.find('.wingo-big');
                var wingoSmall = cItem.find('.wingo-small');
                var wingoHorizontal = cItem.find('.wingo-horizontal');
                var wingoVertical = cItem.find('.wingo-vertical');

                if (window.isPhoneOrTablet) {
                    cItem.find('.wingo-big').attr('src', cItem.find('.wingo-big').attr('data-src'));
                    cItem.find('.wingo-small').remove();
                    cItem.find('.wingo-vertical').remove();
                    cItem.find('.wingo-horizontal').remove();
                } else {
                    if ("wingo-" + wingoClass == wingoBig.attr("class")) {
                        cItem.find('.wingo-big').attr('src', cItem.find('.wingo-big').attr('data-src'));
                    } else {
                        cItem.find('.wingo-big').remove();
                    }
                    if ("wingo-" + wingoClass == wingoSmall.attr("class")) {
                        cItem.find('.wingo-small').attr('src', cItem.find('.wingo-small').attr('data-src'));
                    } else {
                        cItem.find('.wingo-small').remove();
                    }
                    if ("wingo-" + wingoClass == wingoHorizontal.attr("class")) {
                        cItem.find('.wingo-horizontal').attr('src', cItem.find('.wingo-horizontal').attr('data-src'));
                    } else {
                        cItem.find('.wingo-horizontal').remove();
                    }
                    if ("wingo-" + wingoClass == wingoVertical.attr("class")) {
                        cItem.find('.wingo-vertical').attr('src', cItem.find('.wingo-vertical').attr('data-src'));
                    } else {
                        cItem.find('.wingo-vertical').remove();
                    }
                }

                if (to) {
                    cItem.find('.fa-map-marker').parent().attr('data-to', to);
                } else {
                    if (meta[3]) {
                        cItem.find('.fa-map-marker').parent().attr('data-to', meta[3].destinationcitycode);
                    }
                }

                cItem.find('.markerLink').on('click', function(el) {
                   if(!self.comingFromUrl()){
                	   if(el.target.parentElement.dataset.fromport != "undefined"){
                		   sessionStorage.setItem('ORIGIN_PORT_CODE', el.target.parentElement.dataset.fromport);
                	   }
                	   
                   }
                  
                    
                    if (el.target.parentElement.dataset.toport == "undefined") {
                        self.goFlightMapWithSessionParams('DESTINATION_CITY_CODE', el.target.parentElement.dataset.to);
                    } 
                    else {
                        self.goFlightMapWithSessionParams("DESTINATION_PORT_CODE", el.target.parentElement.dataset.toport);
                    }
                });

                var bookOrDestinationBtn = (cItem.find('.btn-danger')[0] || cItem.find('.btn-transparent')[0]);
                if (bookOrDestinationBtn && bookOrDestinationBtn.href) {
                    cItem.find('.shareLink').data('shareUrl', bookOrDestinationBtn.href);
                    if (component.componentID && component.componentID.indexOf("tcm") > -1) {
                        cItem.find(".shareLink").data("componentId", component.componentID)
                    } else {
                        cItem.find(".shareLink").data("componentId", "tcm:" + publicationId + "-" + component.componentID)
                    }
                    
                    
                }
               

                cItem.find('.shareLink').on('click', function(e) {

                    if ($(this).data('shareUrl')) {
                        var shareUrl = $(this).data('shareUrl');
                        var promotionOrDestination = shareUrl && shareUrl.indexOf("#") > -1 ? "promotion" : "destination";
                        self.wingoShareBoxViewModel().url(shareUrl);
                        self.wingoShareBoxViewModel().componentId = $(this).data('componentId') + "," + promotionOrDestination;
                        self.wingoShareBoxViewModel().openWingoShareBox();
                    } else {
                        self.getFlightToUrl(e.currentTarget.dataset.to);
                    }

                });

                cItem.find('.wishLink').on('click', function(e) {
                    var toCode = e.currentTarget.dataset.to;
                    var towish = $(this).hasClass('active');
                    if (msLoggedIn) {
                    	if (!towish) {
                            self.addwishcity($(this), toCode, false)
                        } else {
                            self.removewishcity($(this), toCode, false)
                        }
                    } else {
                    	self.openLogin(function() {
                            if (!towish) {
                                self.addwishcity($(this), toCode, true)
                            } else {
                                self.removewishcity($(this), toCode, true)
                            }
                        });
                    }
                });

                cItem.find('.btn-danger').parent().attr('data-promotiondates', JSON.stringify(self.setPromotionKeywords(kw, roundTrip)));
                if(cabinClass){		
                	var cabinLookup;	
                	if(cabinClass=='Business'){		
                    	cabinLookup='Label-REZ-DASH-5022';
                    	 var cabinText=i18n.get(cabinLookup);		
                     	cItem.find('.btn-danger').parent().find('h3').append('<h5>'+ cabinText +'</h5>');
                    }		
                   		
                }
                dataLayerUtil.addProductClickData(cItem.find('.btn-danger'),{data : component,parentIndex : index, position : i});
                cItem.find(".btn-danger").on("click",function(e){
                    
                    sessionStorage.removeItem("PROMOTION_KEYWORD");

                    if (typeof cabinClass !== "undefined" && cabinClass != null && cabinClass != "") {
                        sessionStorage.setItem("FLIGHTTO_INITIAL_CFF_CODE", cabinClass.toUpperCase());
                        
                    }
                    
                    var promotionKeywords=e.target.parentElement.dataset.promotiondates;
                    if(promotionKeywords){
                       
                        sessionStorage.setItem("PROMOTION_KEYWORD", promotionKeywords);
                    }
                    
                   dataLayerUtil.onPromotionClick($(this));
                       
              });
			         

                cItem.find('.btn-transparent').on('click', function() {
                    sessionStorage.removeItem("DESTINATION_BOOKER_VISIBLE");
                    sessionStorage.setItem("DESTINATION_BOOKER_VISIBLE", false);
                });
            }

        };

        self.getFlightToUrl = function(toCityCode) {
            etrAjax.post({
                app : 'app.cms',
                service : '/content/query',
                disableErrorHandling : true,
                disableLoader : true,
                data : {
                    "schema" : "Destination",
                    "keyword" : [ {
                        "Destination City Code" : toCityCode
                    } ],
                    "template" : "Destination Promotion on Flight Map",
                    "maxItems" : 1,
                    "includeMetadata" : true
                },
                callback : function(response) {
                    var el = document.createElement('html');
                    el.innerHTML = response.data.components[0].html;
                    el = el.querySelector('.btn');
                    var url = window.location.protocol + "//" + window.location.host + el.getAttribute('href');

                    self.wingoShareBoxViewModel().url(url);
                    self.wingoShareBoxViewModel().openWingoShareBox();
                }
            });
        };

        self.setPromotionKeywords=function (kw, roundTrip){
            var promotionKeywords={};
            promotionKeywords.code=kw.code;
            promotionKeywords.roundTrip=roundTrip;
            promotionKeywords.departuredateinterval_startdate=kw.departuredateinterval_startdate;
            promotionKeywords.departuredateinterval_enddate=kw.departuredateinterval_enddate;
            promotionKeywords.returndateinterval_startdate= kw.returndateinterval_startdate;
            promotionKeywords.returndateinterval_enddate= kw.returndateinterval_enddate;
            promotionKeywords.invaliddeparturedateinterval_startdate= kw.invaliddeparturedateinterval_startdate;
            promotionKeywords.invaliddeparturedateinterval_enddate=kw.invaliddeparturedateinterval_enddate;
            promotionKeywords.invalidarrivaldateinterval_startdate= kw.invalidarrivaldateinterval_startdate;
            promotionKeywords.invalidarrivaldateinterval_enddate=kw.invalidarrivaldateinterval_enddate;
            
            return promotionKeywords;
        };
        
        self.goFlightMapWithSessionParams = function(sessionKey, sessionVal) {

            if (typeof flightmapLinks != 'undefined' && flightmapLinks.flightmap) { //flightmapLinks ?? sayfa kontrolu mu? 
                if ($(".flightControl>div>button>span>span:nth-child(3)").hasClass("label-full")) {
                    $(".flight-map-earth-btn").click();
                } else {
                    sessionStorage.setItem(sessionKey, sessionVal);
                    self.redirectTo(flightmapLinks.flightmap + '?map=true');
                }
            } else if (typeof wingoblockLinks != 'undefined' && wingoblockLinks.flightmap) {
                sessionStorage.setItem(sessionKey, sessionVal);
                self.redirectTo(wingoblockLinks.flightmap + '?map=true')
            }

        };
        
        self.redirectTo = function(url) {
            window.location = url;
        };
		self.openLogin = function(callback) {
			Eteration.loadStaticFragment({
				app : 'app.ms',
				module : 'login',
				el : $('#siginModalContainer'),
				success : function() {
					$('#signinModal').modal("show");
					var refreshCurrentPage = false;
					msLoggedIn=window.loggedIn();
					ko.applyBindings(new loginView.ViewModel(callback, refreshCurrentPage), $("#siginModalContainer")[0]);
				}
			});
		};

		function handleWishListOperations() {

			if (self.userWishList() && self.processedWingoItems()) {

				for (var i = 0; i < self.userWishList().length; i++) {
					var cityCode = self.userWishList()[i].cityCode;

					for (var j = 0; j < self.processedWingoItems().length; j++) {
						var processedWingoCityCode = self.processedWingoItems()[j].toCityCode;
						if (cityCode == processedWingoCityCode) {
							// kacinci carousel'de oldugunu asagidaki
							// ile buluyoruz
							var wingoCityCarouselOrder = Math.ceil((j + 1) / 5);
							var cItem = $("#carouselContainer" + wingoCityCarouselOrder).find('.c1_' + j % 5);
							cItem.find('.fa-heart').parent().removeClass("white");
							cItem.find('.fa-heart').parent().addClass("active");
							cItem.find('.fa-heart').parent().attr('data-wish', true);
						}
					}
				}
			}

		}

		self.checkWishList = function() {
			if (window.hasOwnProperty('loggedIn')) {
				msLoggedIn=window.loggedIn();
			}
			if (wishListCotrolled) {
				handleWishListOperations();
			} else {
				etrAjax.get({
					app : 'app.ms',
					service : '/miles/displaywishlist',
					disableLoader : true,
					callback : function(response) {
						wishListCotrolled = true;
						self.userWishList(response.data);
						handleWishListOperations();

					}
				});
			}

		};

		self.addwishcity = function(cItem, toCode, reload) {
			etrAjax.post({
				app : 'app.ms',
				service : '/miles/addwishcity',
				data : toCode,
				disableLoader : true,
				callback : function(response) {
					wishListCotrolled = false;
					if (reload) {
						if (typeof wingoblockLinks != 'undefined' && wingoblockLinks.flightmap) {
							// burası anasayfa
						} else if (typeof flightmapLinks != 'undefined' && flightmapLinks.flightmap) {
							// burası flightmap
							sessionStorage.setItem('isDestination', 'true');
						}
						setTimeout(function() {
							window.location.reload();
						}, 300);
					} else {
						if (response.data > -1) {
							cItem.find('.fa-heart').parent().removeClass("white");
							cItem.find('.fa-heart').parent().addClass("active");
							cItem.find('.fa-heart').parent().attr('data-wish', true);
						} else {
							var refreshCurrentPage = false;
							var headerText = null;
							etrAjax.showInfoModal(headerText, [ "ERR-MS-MILES-6577" ], refreshCurrentPage);
						}
					}
				}
			});
		};

		self.removewishcity = function(cItem, toCode, reload) {
			etrAjax.post({
				app : 'app.ms',
				service : '/miles/remove/code',
				data : toCode,
				disableLoader : true,
				callback : function(response) {
					wishListCotrolled = false;
					if (response.data > -1) {
						cItem.find('.fa-heart').parent().removeClass("active");
						cItem.find('.fa-heart').parent().addClass("white");
						cItem.find('.fa-heart').parent().attr('data-wish', false);
						if (reload) {
							if (wingoblockLinks && wingoblockLinks.flightmap) {
								// burası anasayfa
							} else if (flightmapLinks && flightmapLinks.flightmap) {
								// burası flightmap
								sessionStorage.setItem('isDestination', 'true');
							}
							setTimeout(function() {
								window.location.reload();
							}, 400);
						}
					}
				}
			});
		};
		

		
	};
	var getInstance = function() {
		if (!promotionHelper) {
			promotionHelper = new PromotionHelper();
		}
		return promotionHelper;
	};
	return {
		getInstance : getInstance
	}
});
